import React from 'react';
import { _ } from '../../../functions/translator';
import { parseDate } from '../../../functions/utils';

class FinishDateInfo extends React.Component{

    render(){
        const finishDate = this.props.cardsGroupData.attributes.finish_date;
        if (!finishDate) return null;
        return (
            <div className='info-container'>
                <p className='card-text'>{ _("Fecha de Término") }</p>
                <span className='text card-description'>
                    {parseDate(finishDate)}
                </span>
            </div>
        );
    }
}

export default FinishDateInfo;